module.exports = __webpack_public_path__ + "img/p1-t6.e258b4be.png";